<template>
  <v-container fluid>
    <h1>Welkom</h1>
    <p>Dit is de website die hoort bij de app '75 jaar bevrijding Ommen'.</p>
    <h2>Over de app:</h2>
    <p>
      Fiets, wandel, of rijd langs interessante plaatsen uit de tweede wereldoorlog. Rijd rond en ontdek, of volg één van de routes. Zo kun je bijvoorbeeld treden in de voetsporen van de Canadese verkenners die Ommen hebben bevrijd in 1945, of rondkijken in kamp Erika.
      Ook kun je Stolpersteine ontdekken in het Centrum van Ommen.
    </p>
    <p>Niet zo actief? Je kunt ook gewoon lekker vanuit huis de omgeving ontdekken en lezen wat zich allemaal heeft afgespeeld.</p>
    <p>Met deze app ontdek en zie je de plaatsen waar is gevochten en waar nog steeds sporen te vinden zijn van de oorlog, ook na 75 jaar.</p>
    <p>
      <router-link :to="'download'">Download hem nu</router-link> voor jouw telefoon of tablet!
    </p>
  </v-container>
</template>

<script>
export default {};
</script>

<style>
</style>
